export function saveAuth(
  data
) {

  localStorage.setItem(
    "auth",
    JSON.stringify(data)
  );
}

export function getAuth() {

  const auth =
    localStorage.getItem(
      "auth"
    );

  return auth
    ? JSON.parse(auth)
    : null;
}

export function clearAuth() {

  localStorage.removeItem(
    "auth"
  );
}

export function getAccessToken() {

  const auth =
    getAuth();

  return (
    auth?.accessToken ||
    null
  );
}

export function getRefreshToken() {

  const auth =
    getAuth();

  return (
    auth?.refreshToken ||
    null
  );
}

export function getCurrentApp() {

  const auth =
    getAuth();

  return (
    auth?.apps?.[0] ||
    null
  );
}